import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { BaseVisualizacaoSubCadastro, BaseVisualizacaoSubCadastroService, DataTablesService } from '../../../../core';

import { LeadEndereco } from './lead-endereco';
import { LeadEnderecoFormComponent } from './form';

@Component({
    selector: 'sgt-lead-endereco',
    templateUrl: './lead-endereco.component.html',
    styleUrls: ['./lead-endereco.component.less']
})
export class LeadEnderecoComponent implements BaseVisualizacaoSubCadastro<LeadEndereco>, OnInit {
    dataTable: any;
    isFormOpen: boolean;

    @Input() entities: LeadEndereco[];
    @ViewChild('form') form: LeadEnderecoFormComponent;

    constructor(private baseVisualizacaoSubCadastroService: BaseVisualizacaoSubCadastroService,
                private dataTablesService: DataTablesService) { }

    ngOnInit() {
        this.showTable();
    }

    openForm() {
        this.baseVisualizacaoSubCadastroService.openForm(this);
    }

    closeForm() {
        this.baseVisualizacaoSubCadastroService.closeForm(this);
    }

    showTable() {
        this.dataTablesService.showTable('#tableLeadEnderecos', this.dataTable)
            .then(dataTable => this.dataTable = dataTable);
    }

    insert() {
        this.baseVisualizacaoSubCadastroService.insert(this);
    }

    edit(index: number) {
        this.baseVisualizacaoSubCadastroService.edit(this, index);
    }

    delete(index: number) {
        this.baseVisualizacaoSubCadastroService.delete(this, index, this.entities, 'Deseja realmente excluir esse endereço?')
            .then(() => {})
            .catch(() => {});
    }

    onFormSave(entity: LeadEndereco) {
        this.closeForm();
    }

    onFormCancel() {
        this.closeForm();
    }
}
